import type { AudioCue } from './types';

const AUDIO_ROOT = '/assets/audio/legacy';

export interface AudioAssetDefinition {
  readonly url: string;
  readonly gain: number;
  readonly poolSize: number;
}

export const BASE_MUSIC_TRACKS = [
  { url: `${AUDIO_ROOT}/bg1.mp3`, gain: 0.084 },
  { url: `${AUDIO_ROOT}/bg2.mp3`, gain: 0.084 },
  { url: `${AUDIO_ROOT}/bg3.mp3`, gain: 0.084 },
] as const;

export const FEATURE_MUSIC_TRACK = { url: `${AUDIO_ROOT}/yugioh.mp3`, gain: 0.1 } as const;

/** Temporary mix switch: keep the shuffle assets and recipes intact for easy reactivation. */
export const SHUFFLE_AUDIO_ENABLED = false;

export const SAMPLED_CUES: Readonly<Partial<Record<AudioCue, AudioAssetDefinition>>> = {
  draw: { url: `${AUDIO_ROOT}/draw_sound.mp3`, gain: 0.36, poolSize: 4 },
  shuffle: { url: `${AUDIO_ROOT}/shuffle_sound.mp3`, gain: 0.16, poolSize: 4 },
  'card-flip': { url: `${AUDIO_ROOT}/cardflip_sound.mp3`, gain: 0.028, poolSize: 5 },
  'scatter-1': { url: `${AUDIO_ROOT}/scatter_sound.mp3`, gain: 0.1764, poolSize: 4 },
  'scatter-2': { url: `${AUDIO_ROOT}/scatter_sound.mp3`, gain: 0.1694, poolSize: 4 },
  'scatter-3': { url: `${AUDIO_ROOT}/scatter_sound.mp3`, gain: 0.1652, poolSize: 4 },
  'wild-impact': { url: `${AUDIO_ROOT}/wild_impact.mp3`, gain: 0.12, poolSize: 3 },
  'pot-activate': { url: `${AUDIO_ROOT}/activate.mp3`, gain: 0.12, poolSize: 3 },
};

/** Retained as a master asset for compatibility; inactive in the Legacy runtime. */
export const UNUSED_LEGACY_SCATTER_VARIANT = `${AUDIO_ROOT}/scatter_sound2.mp3`;
